<template>
    <div>
        <mvr-inspection-report-list @selectedReport="(report) => $emit('onReport', report)" @add="$emit('add')" @search="fetchInspectionReports" :results="reports" />
        <div v-if="loading" id="loader" class="spinner" />
    </div>
</template>

<script>
import MvrInspectionReportList from '@/components/inspections/mvrInspections/MvrInspectionReportList'
import { restApi } from '@/components/mixins/RestApiMixin'

export default {
    name: 'MvrInspectionReports',
    components: {
        MvrInspectionReportList
    },
    mixins: [restApi],
    props: {
    },
    data: function () {
        return {
            reports: [],
            lastParams: {},
            loading: false
        }
    },
    methods: {
        fetchInspectionReports: function (params) {
            this.reports = []
            this.loading = true
            this.lastParams = params
            this.restFetchParams(this.mvrInspectionUrl, params, (response) => {
                this.reports = response.data
                this.loading = false
            }, () => {
                this.loading = false
            })
        },
        updateReports() {
            this.fetchInspectionReports(this.lastParams)
        }
    }
}
</script>
